<template>
  <v-dialog v-model="showConfirmationModal" max-width="500">
    <v-card>
      <v-card-title>Confirm {{operationType}}</v-card-title>
      <v-card-text>
        <p>Confirm the {{operationType}} amount: <span class="font-weight-bold">${{ amountParsed }}</span></p>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="confirmDeposit"
          :disabled="isLoading"
        >
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            size="20"
            width="2"
            color="white"
          ></v-progress-circular>
          <span v-else>Confirm</span>
        </v-btn>
        <v-btn :disabled="isLoading" color="red" class="white--text" @click="cancelDeposit">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    amount: {
      type: String,
      required: true,
    },
    showConfirmationModal: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    operationType: {
      type: String,
      required: true,
    },
  },
  computed: {
    amountParsed () {
      const parsedNumber = parseFloat(this.amount)
      if (!isNaN(parsedNumber)) {
        // Use toFixed(2) to format the number with 2 decimal places
        return parsedNumber.toFixed(2);
      } else {
        // Handle invalid input (e.g., non-numeric input)
        return '0';
      }
    },
  },
  methods: {
    confirmDeposit() {
      // Emit an event to inform the parent component that the deposit is confirmed
      this.$emit('onConfirm');
    },
    cancelDeposit() {
      // Emit an event to inform the parent component that the deposit is canceled
      this.$emit('onCancel');
    },
  },
};
</script>
